/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { InteractiveComponents } from '../../../../../core/enums';
import { CursorManager } from '../../../../../core/navigation';
import { RootState, useTivoSelector } from '../../../../../core/tivo/tivo-redux-wrapper';
import { Caret } from '../../../../common';

import './OptionListInteractiveLayer.scss';

interface IOptionListInteractiveLayerProps {
    focused: boolean;
}

const OptionListInteractiveLayer: FunctionComponent<IOptionListInteractiveLayerProps> = ({
    focused,
}): JSX.Element => {
    const { activeComponent } = useTivoSelector((state: RootState) => state.interactiveLayer);

    if (!CursorManager.isCursorAppeared()) return <></>;

    return (
        <div className="option-list-caret-container">
            <Caret
                className={`option-list-caret-west ${!focused ? 'option-list-hide-caret' : ''}`}
                direction={InteractiveComponents.WEST}
                visible={focused}
                active={activeComponent === InteractiveComponents.WEST}
            />
            <Caret
                className={`option-list-caret-east ${!focused ? 'option-list-hide-caret' : ''}`}
                direction={InteractiveComponents.EAST}
                visible={focused}
                active={activeComponent === InteractiveComponents.EAST}
            />
        </div>
    );
};

export default OptionListInteractiveLayer;
